import { render, staticRenderFns } from "./modifyLogisticsAddressModal.vue?vue&type=template&id=661cb892"
import script from "./modifyLogisticsAddressModal.vue?vue&type=script&lang=js"
export * from "./modifyLogisticsAddressModal.vue?vue&type=script&lang=js"
import style0 from "./modifyLogisticsAddressModal.vue?vue&type=style&index=0&id=661cb892&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports